<template>
  <v-select
    class="currency-select"
    v-model="model"
    flat
    single-line
    dense
    :items="currencies"
    item-text="label"
    item-value="abbreviation"
    append-icon="mdi-chevron-down"
    outlined
    :menu-props="{ offsetY: true }"
    @change="changeCurrency"
  >
    <template v-slot:selection="{ item, index }">
      {{ currencyLabel }}
    </template>
  </v-select>
</template>

<script>
import currencyMixin from './CurrencyMixin';

export default {
  name: 'CurrencyToggle',
  props: {},
  mixins: [currencyMixin]
};
</script>
<style lang="stylus" scoped>
.v-select.currency-select::v-deep {
  .v-input__control {
    font-size: 0.85rem;
    div {
      margin-bottom: 0;
    }
    fieldset {
      border: none;
    }
    .v-select__selections {
      line-height: 17px;
      color: #ffffff;
      input {
        display: none;
      }
    }
    .v-input__append-inner {
      align-self: unset;
      margin-top: 0px !important;
      i {
        color: #ffffff !important;
        margin-top: 0px;
        &.v-icon {
          font-size: 18px;
        }
      }
    }
  }
  .v-text-field__details {
    display: none;
  }
}
</style>
